import axios from "axios";
import qs from "qs";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const baseUrl = 'https://api.sum.ba/';

const instance = axios.create({
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    baseURL: baseUrl,
    withCredentials: true, // Check cross-site Access-Control
    headers: {
        Accept: "application/json"
    }, // Check cross-site Access-Control
    paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'brackets'});
    }
});



instance.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
instance.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    function(error) {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
            window.location.href = `${baseUrl}sso/login?redirect_to=${location.href}`;
        }

        // if (code === 403) {
        //     serverBus.$emit(
        //         "show-snackbar",
        //         false,
        //         "Nemate dozvolu za pristup ovom dijelu sustava!"
        //     );
        // }

        // Do something with response error
        return Promise.reject(error);
    }
);

export default instance;
